import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Activity } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
    const navigate = useNavigate();
    const hasProcessed = useRef(false);

    useEffect(() => {
        // Prevent double processing in React StrictMode
        if (hasProcessed.current) return;
        hasProcessed.current = true;

        const processAuth = async () => {
            try {
                // Extract session_id from URL fragment
                const hash = window.location.hash;
                const sessionId = new URLSearchParams(hash.replace('#', '?')).get('session_id');

                if (!sessionId) {
                    console.error('No session_id found in URL');
                    navigate('/login', { replace: true });
                    return;
                }

                // Exchange session_id for JWT token
                const response = await axios.post(
                    `${API}/auth/google/session`,
                    {},
                    { headers: { 'X-Session-ID': sessionId } }
                );

                const { token, user } = response.data;

                // Store token and set axios header
                localStorage.setItem('token', token);
                axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;

                // Clean URL and redirect to dashboard with user data
                window.history.replaceState({}, document.title, window.location.pathname);
                navigate('/dashboard', { replace: true, state: { user } });
            } catch (error) {
                console.error('Google auth error:', error);
                navigate('/login', { 
                    replace: true, 
                    state: { error: 'Failed to sign in with Google. Please try again.' }
                });
            }
        };

        processAuth();
    }, [navigate]);

    return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-background">
            <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-primary-600 to-primary-500 flex items-center justify-center shadow-lg shadow-primary/20">
                    <Activity className="w-6 h-6 text-white" />
                </div>
                <span className="font-heading font-bold text-2xl">
                    Medi<span className="text-primary">Guide</span>
                </span>
            </div>
            <div className="spinner w-8 h-8 border-4 border-primary border-t-transparent rounded-full animate-spin" />
            <p className="mt-4 text-muted-foreground">Signing you in...</p>
        </div>
    );
}
